var otsAccountOpenFactory = function($q, $http, $log) {
    //check if user exists
    var  authenticateOTSUserURL = 
    "rest/nonauth/authenticateOtsUser";

    var createShadowAccount = 
    "/participant-web-services/rest/partialauth/ots/shadowAccount";

    return {
        getExistingUserOTS: function(data) {
          var deferred = $q.defer();

          $http.post( __authenticationUrl__ + authenticateOTSUserURL, data)
            .success(function(data) {
              

              // Pass back the confirmation number
              deferred.resolve(data);
            }).error(function(data) {
                              
                                  
              if (data !== null && data.error !== null){
                deferred.reject(data.error);
              }else{
                deferred.reject();
              }

            });
      return deferred.promise;
      }

    }
        
};
otsAccountOpenFactory.$inject = ['$q', '$http', '$log'];
export default otsAccountOpenFactory;